module.exports = require("webextension-polyfill");